module.exports = __webpack_public_path__ + "static/media/tempelforum_tn.c5e70151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/tempelforum_tn.jpg
// module id = 686
// module chunks = 0